var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "p-absolute left-0 bottom-0 w-100-p bg-white",
      class: {
        "top-51":
          _vm.$root.$children[0].activeTab === "message" ||
          _vm.$root.$children[0].activeTab === "contact",
        "top-0": _vm.$root.$children[0].activeTab === "notification",
      },
      style: {
        "padding-top":
          _vm.$root.$children[0].activeTab == "message" ||
          _vm.$root.$children[0].activeTab == "notification"
            ? 0
            : "39px",
      },
    },
    [
      _vm.$root.$children[0].activeTab == "contact"
        ? _c(
            "div",
            {
              staticClass: "p-absolute top-0 left-0 w-100-p h-39 b-b b-c-g-100",
            },
            [
              _c(
                "ul",
                { staticClass: "d-table w-100-p h-100-p" },
                _vm._l(_vm.tabs, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.value,
                      staticClass:
                        "p-relative d-table-cell h-100-p t-a-center v-a-middle cursor-default user-select-none c-blue-hover",
                      class: { "c-blue": _vm.navSelctType === item.value },
                      style: { width: 100 / _vm.tabs.length + "%" },
                    },
                    [
                      _c("label", [
                        _vm._v(_vm._s(item.name)),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.navSelctType,
                              expression: "navSelctType",
                            },
                          ],
                          staticClass: "d-none",
                          attrs: { type: "radio", name: "imNavTabRadio" },
                          domProps: {
                            value: item.value,
                            checked: _vm._q(_vm.navSelctType, item.value),
                          },
                          on: {
                            change: function ($event) {
                              _vm.navSelctType = item.value
                            },
                          },
                        }),
                      ]),
                      _c("i", {
                        staticClass:
                          "d-none p-absolute left-0 right-0 m-auto h-2",
                        class: { "d-block": _vm.navSelctType === item.value },
                        staticStyle: {
                          bottom: "-1px",
                          "background-color": "#653EB3",
                        },
                        style: { width: item.labelWidth },
                      }),
                    ]
                  )
                }),
                0
              ),
            ]
          )
        : _vm._e(),
      _vm.$root.$children[0].activeTab == "message"
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.navSelctType === "3",
                    expression: "navSelctType==='3'",
                  },
                ],
                staticClass: "h-100-p o-auto left-personnel-box",
                attrs: { id: "sessionListBox" },
              },
              [
                _c("im-session-list", {
                  attrs: {
                    width: _vm.width,
                    im: _vm.im,
                    sessions: _vm.sessions,
                    "to-account": _vm.toaccounts,
                  },
                  on: {
                    updatesessions: _vm.updatesessions,
                    deleteLocalSession: _vm.deleteLocalSession,
                    deleteLocalMsgsBySession: _vm.deleteLocalMsgsBySession,
                    addStickTopSession: _vm.addStickTopSession,
                  },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.contactLoading,
                        expression: "contactLoading",
                      },
                    ],
                    staticStyle: { "text-align": "center", padding: "5px" },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/im/loading_button.gif"),
                        width: "16",
                      },
                    }),
                  ]
                ),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.contactItems.length === 0 && !_vm.contactLoading,
                        expression:
                          "contactItems.length===0 && !contactLoading",
                      },
                    ],
                    staticClass: "c-g-200 t-a-center p-y-10",
                  },
                  [_vm._v("没有匹配到组织")]
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.$root.$children[0].activeTab == "contact"
        ? [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.navSelctType === "0",
                    expression: "navSelctType==='0'",
                  },
                ],
                staticClass: "h-100-p o-auto left-personnel-box",
              },
              [
                _vm.kecodeflag
                  ? _c("im-kcode-list", {
                      attrs: {
                        width: _vm.width,
                        items: _vm.kcodeItems,
                        codeflag: _vm.kecodeflag,
                      },
                      on: { createSession: _vm.createSession },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.contactLoading,
                        expression: "contactLoading",
                      },
                    ],
                    staticClass: "p-5 t-a-center b-b b-c-g-100",
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/im/loading_button.gif"),
                        width: "16",
                      },
                    }),
                  ]
                ),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.kcodeItems.length === 0 && !_vm.contactLoading,
                        expression: "kcodeItems.length===0 && !contactLoading",
                      },
                    ],
                    staticClass: "c-g-200 t-a-center p-y-10 b-b b-c-g-100",
                  },
                  [_vm._v("没有匹配到网点")]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.navSelctType === "1",
                    expression: "navSelctType==='1'",
                  },
                ],
                staticClass: "h-100-p o-auto left-personnel-box",
              },
              [
                _c("im-kecontact-list", {
                  attrs: { width: _vm.width, items: _vm.contactItems },
                  on: { createSession: _vm.createSession },
                }),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.contactLoading,
                        expression: "contactLoading",
                      },
                    ],
                    staticStyle: { "text-align": "center", padding: "5px" },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/images/im/loading_button.gif"),
                        width: "16",
                      },
                    }),
                  ]
                ),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.contactItems.length === 0 && !_vm.contactLoading,
                        expression:
                          "contactItems.length===0 && !contactLoading",
                      },
                    ],
                    staticClass: "c-g-200 t-a-center p-y-10",
                  },
                  [_vm._v("没有匹配到组织")]
                ),
              ],
              1
            ),
            !_vm.toAddGroupFlag
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.navSelctType === "2",
                        expression: "navSelctType==='2'",
                      },
                    ],
                    staticClass: "h-100-p o-auto left-personnel-box",
                  },
                  [
                    _vm.groupFlag
                      ? _c("im-group-list", {
                          attrs: {
                            width: _vm.width,
                            items: _vm.teamCurrentList,
                          },
                          on: { createSessionGroup: _vm.createSessionGroup },
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.contactLoading,
                            expression: "contactLoading",
                          },
                        ],
                        staticStyle: { "text-align": "center", padding: "5px" },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/im/loading_button.gif"),
                            width: "16",
                          },
                        }),
                      ]
                    ),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.teamCurrentList.length === 0 &&
                              !_vm.contactLoading,
                            expression:
                              "teamCurrentList.length===0 && !contactLoading",
                          },
                        ],
                        staticClass: "c-g-200 t-a-center p-y-10",
                      },
                      [_vm._v("没有匹配到群组")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm._e(),
      _vm.$root.$children[0].activeTab == "notification"
        ? _vm._l(_vm.msgList, function (item, idx) {
            return _c(
              "div",
              {
                key: idx,
                staticClass:
                  "flex align-items-center justify-content-between msgitem w-100-p h-50 b-b b-c-g-100 cursor-default bg-g-50-hover",
                on: {
                  click: function ($event) {
                    return _vm.clickNotificationType(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "flex align-items-center" }, [
                  _c("img", {
                    staticClass: "msgicon",
                    attrs: { src: item.icon, alt: "" },
                  }),
                  _c("span", { staticClass: "m-l-10 f-w-700" }, [
                    _vm._v(_vm._s(item.msgTitle)),
                  ]),
                  item.total
                    ? _c("span", { staticClass: "numstyle" }, [
                        _vm._v(_vm._s(item.total)),
                      ])
                    : _vm._e(),
                ]),
                _c("span", { staticClass: "msgtime" }, [
                  _vm._v(_vm._s(_vm.lastMsgTime)),
                ]),
              ]
            )
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }